<div class="tabs">
  <div class="tabs__tabs">
    <ng-content select="twaice-fe-tab"></ng-content>
  </div>

  <div class="tabs__content">
    <ng-content select="twaice-fe-tab-content"></ng-content>
  </div>
</div>
